// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"9d5ca89be58d11872c46","524":"b148774d3904b14953e0","588":"b08c3dde963cd2ae93ec"}[chunkId] + ".css";
};